export default "__VITE_ASSET__6Vrf1Qtr__"